"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postAnalyticsAction = postAnalyticsAction;

var _http = require("js-utils/http");

var AJAX_ACTION_URL = '/ajax/analytics/action'; //NB: Migrated from js-utils b/c it is used once
// Use postAnalyticsAction when you want to record analytics but stay on the same page
// records the action via AJAX so it is suboptimal for logging link clicks

function postAnalyticsAction(action, dimensions, metrics) {
  if (!_http.sdkRequest) {
    return;
  }

  (0, _http.sdkRequest)(AJAX_ACTION_URL, {
    method: 'POST',
    body: JSON.stringify({
      action: action,
      dimensions: dimensions,
      metrics: metrics
    })
  });
} // NB: js-utils also had this -- need to see if this url is used/active
// const AJAX_EVENT_CLICK_URL = '/eventclick';
// function recordEventPageView(eid) {
//     if (!fetchEB) {
//         return;
//     }
//     fetchEB(AJAX_EVENT_CLICK_URL, {
//         method: 'POST',
//         body: { eid },
//     });
// }
//# sourceMappingURL=post-analytics-action.js.map